import { createRoot } from 'react-dom/client';
import { Provider } from "react-redux";
import App from "./App";
import store from "./store";
import AuthContext from "~/context/auth";
import SocketContext from "~/context/socket";
import NavigatorContext from "~/context/navigator";
import { HelmetProvider } from 'react-helmet-async';
import AppointmentContext from '~/context/appointment';

const app = (
  <Provider store={store}>
    <AuthContext>
      <SocketContext>
        <AppointmentContext>
          <NavigatorContext>
            <HelmetProvider>
              <App />
            </HelmetProvider>
          </NavigatorContext>
        </AppointmentContext>
      </SocketContext>
    </AuthContext>
  </Provider>
);

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(app);
}
